import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/noto-sans-tc/400.css';
import '@fontsource/noto-sans-tc/500.css';
import '@fontsource/noto-sans-tc/700.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './index.css';
import './i18n/config'; // 初始化 i18n
import App from './App';
import './utils/devTools';
import envConfig from './config/env';

function setMeta(name: string, content: string) {
  const el = document.querySelector(`meta[name="${name}"]`) as HTMLMetaElement | null;
  if (el) el.content = content;
}
function setOg(property: string, content: string) {
  const el = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement | null;
  if (el) el.content = content;
}
function updateSchemaOrg(s: any) {
  const el = document.querySelector('script[type="application/ld+json"]');
  if (!el) return;
  try {
    const json = JSON.parse(el.textContent || '{}');
    json.sameAs = [s.facebookUrl, s.instagramUrl, s.threadsUrl].filter(Boolean);
    el.textContent = JSON.stringify(json);
  } catch {}
}

fetch(`${envConfig.apiUrl}/seo-settings`)
  .then(r => r.json())
  .then(({ data: s }) => {
    if (!s) return;
    if (s.metaTitle) document.title = s.metaTitle;
    if (s.metaDescription) setMeta('description', s.metaDescription);
    if (s.metaKeywords) setMeta('keywords', s.metaKeywords);
    if (s.canonicalUrl) {
      const link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (link) link.href = s.canonicalUrl;
    }
    if (s.ogTitle) setOg('og:title', s.ogTitle);
    if (s.ogDescription) setOg('og:description', s.ogDescription);
    if (s.ogImageUrl) { setOg('og:image', s.ogImageUrl); }
    updateSchemaOrg(s);
  })
  .catch(() => {}); // silently fall back to static index.html values

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

